// 认证头
export const AUTHORIZATION_HEADER = "Authorization";
// Token前缀
export const TOKEN_PREFIX = "Bearer ";

export const AUTH_TOKEN_PREFIX = "__auth_";
// 访问Token Key
export const AUTH_ACCESS_TOKEN_KEY = `${AUTH_TOKEN_PREFIX}access_token__`;
// 刷新Token Key
export const AUTH_REFRESH_TOKEN_KEY = `${AUTH_TOKEN_PREFIX}refresh_token__`;